import { Chip, Stack } from "@mui/material";
import React from "react";

const UsersLocationChips = ({ item }) => {
  const locations = item?.locations;
  return (
    <Stack direction="row" gap="5px">
      {locations?.map(({ location }) => (
        <Chip
          key={location?.name}
          label={location?.name}
          sx={{
            "& .MuiChip-label": {
              fontSize: 10,
            },
          }}
        />
      ))}
    </Stack>
  );
};

export default UsersLocationChips;
